var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayAheadActivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.085 31.067H4.475V17.75h23.028c2.234-2.661 5.592-4.436 9.39-4.436 2.91 0 5.592 1.11 7.826 2.884V4.436a4.41 4.41 0 00-1.31-3.139A4.473 4.473 0 0040.244 0H4.475C3.285 0 2.147.47 1.31 1.297A4.41 4.41 0 000 4.437v26.63a4.41 4.41 0 001.31 3.138 4.473 4.473 0 003.165 1.298h21.61v-4.436zM4.475 4.437h35.77v4.435H4.475V4.436z",
    fill: "#F8991D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.33 28.613V23.62h11.176l-4.348-4.369 3.003-3.018L47 26.12l-9.839 9.888-3.003-3.018 4.348-4.37H27.329v-.006z",
    fill: "#F8991D"
  })));
}
export default __webpack_public_path__ + "static/media/pay-ahead-activate.6b70d473.svg";
export { SvgPayAheadActivate as ReactComponent };